module.exports = __webpack_public_path__ + "static/media/temp--office.9593816a.jpg";